function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { usePopper } from 'react-popper';
import { Popover } from '@headlessui/react';
import { secondsToDate } from "../../../../shared/dateHelpers";


import { Translate } from "../../../../../I18N";

const SuggestedValue = ({
  value,
  suggestion,
  templateProperties




}) => {
  const locale = useParams().lang;
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'top',
    strategy: 'absolute',
    modifiers: [{ name: 'arrow', options: { element: arrowElement } }]
  });
  const [popoverOpen, setPopoverOpen] = useState(false);

  let colorClass = '';
  if (!suggestion || suggestion.suggestedValue === '') {
    colorClass = 'text-orange-600';
  }
  if (value === suggestion.suggestedValue) {
    colorClass = 'text-green-600';
  } else {
    colorClass = 'text-orange-600';
  }

  const property = templateProperties.find((prop) => prop.name === suggestion.propertyName);

  const getCurrentValue = () => {
    if (value === '') return '-';
    if ((property === null || property === void 0 ? void 0 : property.type) === 'date') return secondsToDate(value, locale);
    return value;
  };

  const getSuggestedValue = () => {
    if (suggestion.suggestedValue === '') return '-';
    if ((property === null || property === void 0 ? void 0 : property.type) === 'date') {
      return secondsToDate(suggestion.suggestedValue || '', locale);
    }
    return suggestion.suggestedValue.toString();
  };

  return /*#__PURE__*/(
    _jsx(Popover, {}, void 0, /*#__PURE__*/
    React.createElement(Popover.Button, {
      onMouseOver: () => setPopoverOpen(true),
      onMouseLeave: () => setPopoverOpen(false),
      ref: setReferenceElement,
      className: "w-full h-full text-xs font-normal text-left focus-visible:outline-none hover:cursor-default" }, /*#__PURE__*/

    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "text-gray-500" }, void 0, getCurrentValue()), /*#__PURE__*/
    _jsx("div", { className: `text-left ${colorClass}` }, void 0, getSuggestedValue())
    )
    ),
    popoverOpen && /*#__PURE__*/
    React.createElement(Popover.Panel, _extends({
      static: true,
      ref: setPopperElement,
      style: styles.popper
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, attributes.popper, {
      as: "div" }), /*#__PURE__*/

    _jsx("div", { className: "px-[10px] py-3 rounded mb-3 overflow-y-auto text-xs font-normal text-gray-500 bg-white shadow-md max-h-56 max-w-xs" }, void 0, /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("span", { className: "font-bold" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Current value"), ":"
    ), ' ',
    getCurrentValue()
    ), /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("span", { className: "font-bold" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Suggestion:")
    ), ' ',
    getSuggestedValue()
    )
    ), /*#__PURE__*/
    React.createElement("span", {
      // @ts-ignore
      ref: setArrowElement,
      className: "absolute bottom-[6px] left-0 w-3 h-3 rotate-45 bg-white",
      style: {
        position: styles.arrow.position,
        left: styles.arrow.left,
        transform: `${styles.arrow.transform} rotate(45deg)`,
        boxShadow: '2px 2px 3px rgba(40, 40, 40, 0.1)'
      } }
    )
    )

    ));

};

export { SuggestedValue };